import {cloudloyalty, mileage, PremmiarEndpoint, ConciergeEndpoint} from "../clients";

export const authorizeWithToken = (User) => (
    OrderId,
    PaymentMoneyRequest,
    Token,
    TokenType,
    Resend,
) => {
    return cloudloyalty(User).post('/v1/purchases/withToken', {
        OrderId: OrderId,
        PaymentMoneyRequest: PaymentMoneyRequest,
        Token: Token,
        TokenType: TokenType,
        Resend: Resend  
    })
}

export const authorizeWithTokenMileage = (User, supplierId) => (
    OrderId,
    Token,
    orderMileageId,
) => {
    return mileage(User, supplierId).post(`/v1/orders/withToken?orderId=${OrderId}&token=${Token}&orderMileageId=${ orderMileageId }`)
}

export const authorizeWithTokenLikePlusGamb = (User) => (
    purchaseData,
    OrderId,
    Token,
) => {
    return PremmiarEndpoint(User).post('/v1/focalpoint/orders/redemptionWithToken', {
        ...purchaseData,
        orderId: OrderId,
        token: Token,
    })
}
export const authorizeWithTokenPix = (User) => (
    purchaseData,
    OrderId,
    Token,
) => {
    return PremmiarEndpoint(User).post('/v1/pix/credit/transfer/withToken', {
      ...purchaseData,
      orderId: OrderId,
      token: Token,
    });
}

export const authorizeWithTokenResend = (User) => (
    OrderId,
    PaymentMoneyRequest,
    Token,
    TokenType,
    Resend,
) => {
    return cloudloyalty(User).post('/v1/purchases/generateToken', {
        OrderId: OrderId,
        PaymentMoneyRequest: PaymentMoneyRequest,
        Token: Token,
        TokenType: TokenType,
        Resend: Resend
    })
}

export const authorizeWithTokenConcierge = () => (
    purchaseData,
    OrderId,
    Token,
) => {
    const url = purchaseData.url;
    const headers = purchaseData.headers;
    const body = purchaseData.body;

    return ConciergeEndpoint(headers).post(url, {
        ...body,
        tokenValidation: {
            orderId: OrderId,
            token: Token,
        }
    });
}


